import React from 'react'
import './App.css'
import Weather from './Components/weatherapp'

function App() {
  return (
    <div>
      <Weather/>
    </div>
  );
}

export default App;
